<template>
    <transition name="fade">
        <div class="pt-popup__wrapper">
            <div
                :class="['pt-popup__container', topColor && 'pt-popup__border']"
                :style="popupStyle"
            >
                <div class="pt-popup__close" @click="handleCloseClick" v-if="showClose">
                    <pt-icon icon="pt-icon--close" :style="{ width: '12px', height: '12px' }"></pt-icon>
                </div>
                <div class="pt-popup__content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
export default defineComponent({
    name: 'ptPopup',
    props: {
        width: {
            type: String,
            default: 'auto'
        },
        top: {
            type: String,
            default: '15vh'
        },
        showClose: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        topColor: String
    },
    emits: ['close'],
    setup(props: any, { emit }) {
        const popupStyle = computed(() => {
            let popupStyle: any = {
                width: props.width,
                marginTop: props.top
            };
            if (props.topColor) {
                popupStyle.borderColor = props.topColor;
            }
            return popupStyle;
        });

        return {
            popupStyle,
            handleCloseClick
        };

        function handleCloseClick() {
            emit('close');
        }
    }
});
</script>